import { internal, template } from '../../vendor/elix.js';

function EmptyValueMixin(Base) {

  return class EmptyValue extends Base {

    [internal.render](changed) {
      super[internal.render](changed);
      if (changed.type) {
        this.renderType();
      }
      this.renderEmptyClass();
    }

    get empty() {
      return !this.value;
    }

    renderEmptyClass() {
      const inner = this[internal.ids].inner;
      if (inner) {
        if (this.empty) {
          inner.classList.add('empty');
        } else {
          inner.classList.remove('empty');
        }
      }
    }

  }

}

export default EmptyValueMixin;
